import Swiper, { Navigation, Autoplay } from 'swiper';

const testimonialsSlider = new Swiper('.TestimonialsSlider .swiper', {
    modules: [Navigation, Autoplay],
    loop: true,
    autoplay: {
        delay: 7000,
    },
    slidesPerView: 'auto',
    spaceBetween: 32,
    navigation: {
        nextEl: '.TestimonialsSlider__pagination .next',
        prevEl: '.TestimonialsSlider__pagination .prev',
    },
});
